import { Box, Card, Grid, IconButton, InputAdornment, Switch, TextField, Tooltip, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Loading from '../../../../../components/Loader/Loading';
import NoRowsLayout from '../../../../../components/Layout/NoRowsLayout';
import { Delete, Edit, RestartAlt } from '@mui/icons-material';
import { Search } from '@mui/icons-material';
import { usePermission } from '../../../../../hooks/usePermission';
import useResponsive from '../../../../../hooks/useResponsive'
import { DuplicateEntryDataContext } from './MultipleDuplicateSlabCreate';
import MultiColumnFilter from '../../../../../components/Filter/MultiColumnFilter';
import { Controller, useForm } from 'react-hook-form';
import { PermissionGuard } from '../../../../../components/PermissionGuard';
import Swal from 'sweetalert2';
import { SlabServices } from '../SlabServices';

const SelectedCategorySlabList = () => {
  const {isSm} = useResponsive();
  const userPermissions = usePermission("gst");
  const showActionColumn = userPermissions.canEdit;
  const { control, handleSubmit,getValues, reset } = useForm();
  const {fetchSlabList,slabList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedSlabData, setSelectedSlabData,categoryList,urbanTypeList} = useContext(DuplicateEntryDataContext);
  const columns = [
      {field:'id',headerName:'Id',headerAlign:'center',flex:.25,
          renderCell : (params)=>(
              <Box sx={{width:'100%',textAlign:'center'}}>
                  <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.id}</Typography>
              </Box>
          )
      },
      // {field:'category',headerName:'Category',headerAlign:'center',sortable:false,flex:1.25,
      //     renderCell : (params)=>(
      //         <Box sx={{width:'100%',p:.5}}>
      //             <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row?.category?.title}</Typography>
      //         </Box>
      //     )
      // },
      // {field:'urbanType',headerName:'Urban Type',headerAlign:'center',sortable:false,flex:1.25,
      //     renderCell : (params)=>(
      //         <Box sx={{width:'100%',p:.5}}>
      //             <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row?.urban?.typeTitle}</Typography>
      //         </Box>
      //     )
      // },
      {field:'other',headerName:`Other Detail's`,headerAlign:'center',sortable:false,flex:1.5,
          renderCell : (params)=>(
              <Box sx={{width:'100%',p:0}}>
                <Box sx={{display:'flex',gap:1, }}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >Booking Order Range</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.orderStart} - {params.row.orderEnd}</Typography>
                </Box>
                <Box sx={{display:'flex',gap:1, }}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >Category</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row?.category?.title}<Box component={'span'} sx={{color:'#1976d2',fontSize:'0.65rem',fontweight:500}}>_({params.row?.category?.id})</Box></Typography>
                </Box>
                <Box sx={{display:'flex',gap:1, }}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >Subscription Type</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row?.urban?.typeTitle}<Box component={'span'} sx={{color:'#1976d2',fontSize:'0.65rem',fontweight:500}}>_({params.row?.urban?.id})</Box></Typography>
                </Box>
              </Box>
          )
      },
      {field:'chargeDetails',headerName:`Charge Detail's`,headerAlign:'center',sortable:false,flex:1.5,
          renderCell : (params)=>(
              <Box sx={{width:'100%',p:0}}>
                {/* <Box sx={{display:'flex',gap:1, }}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >Booking Order Range</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.orderStart} - {params.row.orderEnd}</Typography>
                </Box> */}
                <Box sx={{display:'flex',gap:1, }}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >Subscription Fee</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >₹ {params.row.subscriptionFee}</Typography>
                </Box>
                <Box sx={{display:'flex',gap:1, }}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >Subscription Fee (with GST)</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >₹ {params.row.subscriptionFeeWithGst}</Typography>
                </Box>
              </Box>
          )
      },
      {field:'status',headerName:'Status',headerAlign:'center',sortable:false,flex:.35,
          renderCell : (params)=>(
              <Box sx={{display:'flex',flexDirection:'column',gap:1,alignItems:'center',width:'100%'}}>
                <PermissionGuard feature={'subscription-slab'} permission='canEdit' >
                <Switch
                  size='small'
                  checked={params.row.status}
                  onChange={()=>handleStatusChange(params.row.id)}
                  disabled={true}
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                        color: 'success.main',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: 'success.main'
                    },
                    '& .MuiSwitch-switchBase': {
                        color: 'error.main',
                    },
                    '& .MuiSwitch-track': {
                        backgroundColor: 'error.main'
                    }
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                </PermissionGuard>
                <Typography
                  variant="body2"
                  size="small"
                  sx={{
                    color: params.row?.status ? 'success.main' : 'error.main',
                    fontWeight: '600',
                    fontSize:'.65rem'
                  }}
                >
                  {params.row?.status ? 'Active' : 'Inactive'}
                </Typography>
            </Box>
          )
      },
  ]

  const handlePaginationChange = (newPagination) => {
      setPaginationModel({
          ...paginationModel,
          page: newPagination.page,
          pageSize: newPagination.pageSize
      });
  }
  function onSubmit(data) {
      const filtersData = getValues();
      setPaginationModel({
        ...paginationModel,
        filters: {
          ...paginationModel.filters,
          searchKey: filtersData.searchKey,
        }
      });
  }

  const clearFilters = () => {
      reset({
        searchKey: "",
      });
      setPaginationModel({
        ...paginationModel,
        filters: {
          ...paginationModel.filters,
          searchKey: "",
          sortBy: 'createdAt',
          sortType: 'desc',
          filterOptions: []
        }
      });
  
      // Trigger clear for MultiColumnFilter
      setClearMultiFilter(true);
  
      // Reset the clear trigger after a short delay
      setTimeout(() => setClearMultiFilter(false), 100);
  }
  
  useEffect(()=>{
      fetchSlabList();
  },[paginationModel]);
  /************  MultiColumn FIlter related  **************/
  const filterableColumns = [
      {
        key: 'categoryId',
        label: 'Category',
        type: 'select',
        options: categoryList.map((category) => ({
          value: category.id,
          label: category.title
        }))
      },
      {
        key: 'SubscriptionUrbanTypeId',
        label: 'Subscription Type',
        type: 'select',
        options: urbanTypeList.map((urbanType) => ({
          value: urbanType.id,
          label: urbanType.typeTitle
        }))
      },
      {
        key: 'status',
        label: 'Status',
        type: 'select',
        options: [
          { value: "true", label: 'Active' },
          { value: "false", label: 'In-Active' }
        ]
      },
      {
        key: 'order-range',
        label: 'Order Range',
        type: 'number-range'
      }
  ];
  const handleApplyFilter = (filterData) => {
      // Process filter data
      console.log(filterData);
      setPaginationModel({
        ...paginationModel,
        page: 0, // Reset to first page when applying new filters
        filters: {
          ...paginationModel.filters,
          // Convert MultiColumnFilter options to a format your backend can understand
        filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
        }
      });
  }
  const [clearMultiFilter, setClearMultiFilter] = useState(false);


  // Properly structured filter model
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: []
  });

  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
      {
        field: paginationModel.filters.sortBy,
        sort: paginationModel.filters.sortType,
      },
  ]);
  
  const handleSortingChange = (newSortModel) => {
      if (newSortModel && newSortModel.length > 0) {
        setSortModel(newSortModel);
        setPaginationModel(prev => ({
          ...prev,
          filters: {
            ...prev.filters,
            sortBy: newSortModel[0].field,
            sortType: newSortModel[0].sort
          }
        }));
      }
  }
  
  const handleStatusChange = async (id) =>{
    const isResult = await Swal.fire({
      title: 'Are you sure?',
      text: `You want to change the status of this slab!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, change it!',
      cancelButtonText: 'No, keep it'
    });
    if(isResult.isConfirmed){
      Swal.fire({
        title: 'Processing',
        html: 'Please wait...',
        didOpen: () => {
          Swal.showLoading();
        },
      })
      const result = await SlabServices.updateSlabStatus(id);
      if(result.success == '1'){
        Swal.fire({
          title: 'Success!',
          text: result.message,
          icon: 'success',
          timer: 1500
        })
        fetchSlabList();
      }else{
        Swal.fire({
          title: 'Failed!',
          text: result.message,
          icon: 'error'
        });
      }
    }
  }

  const handleDelete = async (slabData) => {
    const isResult = await Swal.fire({
      title: 'Are you sure?',
      text: `You want to delete this slab!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    });
    if(isResult.isConfirmed){
      Swal.fire({
        title: 'Processing',
        html: 'Please wait...',
        didOpen: () => {
          Swal.showLoading();
        },
      })
      const result = await SlabServices.deleteSlab(slabData.id);
      if(result.success == '1'){
        Swal.fire({
          title: 'Success!',
          text: result.message,
          icon: 'success',
          timer: 1500
        })
        fetchSlabList();
      }else{
        Swal.fire({
          title: 'Failed!',
          text: result.message,
          icon: 'error'
        });
      }
    }
  }
  return (
    <Card>
        <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
            <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >Subscription Slab List</Typography>
        </Box>
        <Box>
            {/* custom toolbar */}
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between',alignItems:'center',px:'1%' }}>
              <Box sx={{ display: 'none', gap: 1 }}>
                <MultiColumnFilter
                  filterableColumns={filterableColumns}
                  onApplyFilter={handleApplyFilter}
                  externalClear={clearMultiFilter}
                  defaultFilterOptions={paginationModel.filters.filterOptions}
                />
              </Box>
            </Box>
            <DataGrid
                rows={slabList}
                columns={columns.map((col) => ({
                  ...col,
                  // flex: col.flex || 1, // Ensure columns resize dynamically
                  minWidth: isSm && (col.minWidth || 150), // Set a minimum width to avoid overlap
                }))}
                // getRowId={(row) => row.id}
                //checkboxSelection={true}
                rowCount={totalRowCount}  // Use the length of the filtered list
                pageSizeOptions={[5, 10, 20, 50, 100]}
                paginationModel={paginationModel}
                paginationMode="server"
                onPaginationModelChange={handlePaginationChange}

                filterModel={filterModel}

                sortingMode="server"
                sortModel={sortModel}                  
                onSortModelChange={handleSortingChange}
                disableMultiSort={true}
                
                sortingOrder={['asc', 'desc']}

                loading={loadingList}

                disableColumnMenu
                disableRowSelectionOnClick
                slots={{
                    // toolbar: GridToolbar,                        
                    loadingOverlay: Loading,
                    noRowsOverlay: NoRowsLayout,
                }}
                // autoHeight
                getRowHeight={() => 'auto'}
                sx={{
                  height:'63vh',
                    borderRadius:'0',
                    '& .MuiDataGrid-cell': {
                    border: 1,
                    borderRight: 0,
                    borderTop: 0,
                    borderColor: 'lightgrey',
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: 'center',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                    //   borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p:0,
                        height: 'fit-content',
                        minHeight:'0 !important',
                        height:'2rem'
                    },
                    '& .MuiDataGrid-columnHeader': {
                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                    borderBottom: 'none',
                    '&:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 600,
                    color: '#3e3e3e'
                    },
                    '& .MuiDataGrid-row': {
                        '& .MuiDataGrid-cell:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    },
                    '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                    },
                }}
            />
        </Box>
    </Card>
  );
}

export default SelectedCategorySlabList;
